"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description selection range API
 * @author wangfupeng
 */
var dom_core_1 = __importDefault(require("../utils/dom-core"));
var util_1 = require("../utils/util");
var index_1 = __importDefault(require("./selection-range-top-nodes/index"));
var SelectionAndRange = /** @class */ (function () {
    function SelectionAndRange(editor) {
        this.editor = editor;
        this._currentRange = null;
    }
    /**
     * 获取当前 range
     */
    SelectionAndRange.prototype.getRange = function () {
        return this._currentRange;
    };
    /**
     * 保存选区范围
     * @param _range 选区范围
     */
    SelectionAndRange.prototype.saveRange = function (_range) {
        if (_range) {
            // 保存已有选区
            this._currentRange = _range;
            return;
        }
        // 获取当前的选区
        var selection = window.getSelection();
        if (selection.rangeCount === 0) {
            return;
        }
        var range = selection.getRangeAt(0);
        // 获取选区范围的 DOM 元素
        var $containerElem = this.getSelectionContainerElem(range);
        if (!$containerElem) {
            // 当 选区范围内没有 DOM元素 则抛出
            return;
        }
        if ($containerElem.attr('contenteditable') === 'false' ||
            $containerElem.parentUntil('[contenteditable=false]')) {
            // 这里大体意义上就是个保险
            // 确保 编辑区域 的 contenteditable属性 的值为 true
            return;
        }
        var editor = this.editor;
        var $textElem = editor.$textElem;
        if ($textElem.isContain($containerElem)) {
            // 是编辑内容之内的
            this._currentRange = range;
        }
    };
    /**
     * 折叠选区范围
     * @param toStart true 开始位置，false 结束位置
     */
    SelectionAndRange.prototype.collapseRange = function (toStart) {
        if (toStart === void 0) { toStart = false; }
        var range = this._currentRange;
        if (range) {
            range.collapse(toStart);
        }
    };
    /**
     * 获取选区范围内的文字
     */
    SelectionAndRange.prototype.getSelectionText = function () {
        var range = this._currentRange;
        if (range) {
            return range.toString();
        }
        else {
            return '';
        }
    };
    /**
     * 获取选区范围的 DOM 元素
     * @param range 选区范围
     */
    SelectionAndRange.prototype.getSelectionContainerElem = function (range) {
        var r;
        r = range || this._currentRange;
        var elem;
        if (r) {
            elem = r.commonAncestorContainer;
            return dom_core_1.default(elem.nodeType === 1 ? elem : elem.parentNode);
        }
    };
    /**
     * 选区范围开始的 DOM 元素
     * @param range 选区范围
     */
    SelectionAndRange.prototype.getSelectionStartElem = function (range) {
        var r;
        r = range || this._currentRange;
        var elem;
        if (r) {
            elem = r.startContainer;
            return dom_core_1.default(elem.nodeType === 1 ? elem : elem.parentNode);
        }
    };
    /**
     * 选区范围结束的 DOM 元素
     * @param range 选区范围
     */
    SelectionAndRange.prototype.getSelectionEndElem = function (range) {
        var r;
        r = range || this._currentRange;
        var elem;
        if (r) {
            elem = r.endContainer;
            return dom_core_1.default(elem.nodeType === 1 ? elem : elem.parentNode);
        }
    };
    /**
     * 选区是否为空（没有选择文字）
     */
    SelectionAndRange.prototype.isSelectionEmpty = function () {
        var range = this._currentRange;
        if (range && range.startContainer) {
            if (range.startContainer === range.endContainer) {
                if (range.startOffset === range.endOffset) {
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * 恢复选区范围
     */
    SelectionAndRange.prototype.restoreSelection = function () {
        var selection = window.getSelection();
        var r = this._currentRange;
        if (selection && r) {
            selection.removeAllRanges();
            selection.addRange(r);
        }
    };
    /**
     * 创建一个空白（即 &#8203 字符）选区
     */
    SelectionAndRange.prototype.createEmptyRange = function () {
        var editor = this.editor;
        var range = this.getRange();
        var $elem;
        if (!range) {
            // 当前无 range
            return;
        }
        if (!this.isSelectionEmpty()) {
            // 当前选区必须没有内容才可以，有内容就直接 return
            return;
        }
        try {
            // 目前只支持 webkit 内核
            if (util_1.UA.isWebkit()) {
                // 插入 &#8203
                editor.cmd.do('insertHTML', '&#8203;');
                // 修改 offset 位置
                range.setEnd(range.endContainer, range.endOffset + 1);
                // 存储
                this.saveRange(range);
            }
            else {
                $elem = dom_core_1.default('<strong>&#8203;</strong>');
                editor.cmd.do('insertElem', $elem);
                this.createRangeByElem($elem, true);
            }
        }
        catch (ex) {
            // 部分情况下会报错，兼容一下
        }
    };
    /**
     * 根据 DOM 元素设置选区
     * @param $elem DOM 元素
     * @param toStart true 开始位置，false 结束位置
     * @param isContent 是否选中 $elem 的内容
     */
    SelectionAndRange.prototype.createRangeByElem = function ($elem, toStart, isContent) {
        if (!$elem.length) {
            return;
        }
        var elem = $elem.elems[0];
        var range = document.createRange();
        if (isContent) {
            range.selectNodeContents(elem);
        }
        else {
            // 如果用户没有传入 isContent 参数，那就默认为 false
            range.selectNode(elem);
        }
        if (toStart != null) {
            // 传入了 toStart 参数，折叠选区。如果没传入 toStart 参数，则忽略这一步
            range.collapse(toStart);
        }
        // 存储 range
        this.saveRange(range);
    };
    /**
     * 获取 当前 选取范围的 顶级(段落) 元素
     * @param $editor
     */
    SelectionAndRange.prototype.getSelectionRangeTopNodes = function (editor) {
        var item = new index_1.default(editor);
        item.init();
        return item.getSelectionNodes();
    };
    /**
     * 移动光标位置
     * @param {Node} node 元素节点
     */
    SelectionAndRange.prototype.moveCursor = function (node) {
        var range = this.getRange();
        var pos = node.childNodes.length;
        if (!range) {
            return;
        }
        if (node) {
            range.setStart(node, pos);
            range.setEnd(node, pos);
            this.restoreSelection();
        }
    };
    return SelectionAndRange;
}());
exports.default = SelectionAndRange;
